export function groupBy(array: any[], key: any): { [x: string]: any } {
    return (array || []).reduce((r: any, x: { [x: string]: any }) => ({ ...r, [key ? x[key] : x]: x }), {});
}
